import { assignProps } from '@nzyme/utils/assignProps.js';
import { stringifyKey } from './utils/stringifyKey.js';
export function defineActorUser(definition) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getter = (id) => stringifyKey(definition.type, id);
    const user = assignProps(getter, definition);
    return user;
}
//# sourceMappingURL=ActorUser.js.map